import { render } from "./Form-Inbound.vue?vue&type=template&id=baccfd64"
import script from "./Form-Inbound.vue?vue&type=script&lang=js"
export * from "./Form-Inbound.vue?vue&type=script&lang=js"

import "./Form-Inbound.vue?vue&type=style&index=0&id=baccfd64&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBreadcrumbs from 'quasar/src/components/breadcrumbs/QBreadcrumbs.js';
import QBreadcrumbsEl from 'quasar/src/components/breadcrumbs/QBreadcrumbsEl.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QTable from 'quasar/src/components/table/QTable.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QBreadcrumbs,QBreadcrumbsEl,QInput,QIcon,QPopupProxy,QDate,QBtn,QSpace,QMarkupTable,QImg,QFooter,QDialog,QPagination,QScrollArea,QToolbar,QCardActions,QTable});qInstall(script, 'directives', {ClosePopup});
